(ns common.schema.entities.workspace.kyc.contract-kyc-profile.core
  (:require [common.features.plan :as plan]
            [common.schema.entities.permissions :as entity-permissions]
            [common.schema.entities.workspace.kyc.contract-kyc-profile :as contract-kyc-profile]))

;; Verbatim copy of common.schema.entity-types's existing contract-kyc-profile
;; entry (entity_types.cljc around line 1430-1444) - required here, not
;; there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
(defn- read-permissions-check-fn
  [{:keys [account-current-permissions tenant role tenant-plan]}]
  (and (plan/available :feature/contract-kyc tenant role tenant-plan)
       (contains? (:account-modules account-current-permissions)
                  :module/contract-kyc)))

(def entity-type-definition
  {:entity-type                  :entity.type/contract-kyc-profile
   :schema                       contract-kyc-profile/schema
   :name                         {:en "Contract KYC profile"}
   :plural                       {:en "Contract KYC profiles"}
   :icon                         :fa-shield-check
   :entity/mcp-blacklisted?      true
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn entity-permissions/disable-when-no-write-permission

   ;; Unlike most already-ported entities, contract-kyc-profile has no
   ;; pre-existing legacy dedicated OpenSearch index (its legacy
   ;; common.opensearch.entity-indices entry is an empty map, "TODO
   ;; universal indexing"). Leaving :search-index? unset lets it default to
   ;; true (since :search is present below), routing dedicated indexing
   ;; through the newer backend.search.dedicated.indexes/init! bootstrap -
   ;; the index is created and re-indexed explicitly as part of this port,
   ;; matching sale-agreement's port (see ai/mistakes.md).
   ;;
   ;; :contract-kyc-profile/name is a calculated field (composite of just
   ;; :contract-kyc-profile/target's display string, via
   ;; su/text-simple-field's :composite-attributes support) - it only ever
   ;; materializes into the dedicated OpenSearch index through the modern
   ;; per-entity-type materialization pipeline, which is why the backend
   ;; registration above is required. Deliberately used here instead of
   ;; :common/display-name (which fund-commitment's core.cljc uses): a
   ;; kanban card's title/body only ever reads flat.<alias> paths
   ;; (ui.view.kanban-opensearch.event/compile-card-field), and
   ;; :common/display-name is never flattened (only materialized under
   ;; original/system) - using it as a listing's :result/title-attr renders
   ;; a working grid column but silently produces zero kanban cards. Every
   ;; other consumer of common.schema.display-name/compute (NEV,
   ;; notifications, etc.) still gets a good name for this entity type via
   ;; the existing common.entity/display-string case
   ;; ("<target>'s Contract KYC profile") - no custom :display-name-fn
   ;; needed here.
   :search                       {:result/title-attr :contract-kyc-profile/name
                                  :list/default-columns [:contract-kyc-profile/name
                                                         :contract-kyc-profile/status
                                                         :contract-kyc-profile/next-deadline
                                                         :contract-kyc-profile/latest-process-status
                                                         :contract-kyc-profile/their-kyc-contact
                                                         :contract-kyc-profile/our-kyc-contact]
                                  :views {:grid {:po-default-field-paths [[:contract-kyc-profile/name]
                                                                          [:contract-kyc-profile/status]
                                                                          [:contract-kyc-profile/next-deadline]
                                                                          [:contract-kyc-profile/latest-process-status]
                                                                          [:contract-kyc-profile/their-kyc-contact]
                                                                          [:contract-kyc-profile/our-kyc-contact]]
                                                 :mandatory-field-paths [[:contract-kyc-profile/name]]}}}})
